// extracted by mini-css-extract-plugin
export default {"container":"mEGZoaB0WZ8_rE3udt8Q","gridItem":"CSUHusUD8iaYYWtUYR3w","featuredItem":"KZ089ofC9fna6n9XbI6o","regularItem":"GuZVaaXfiB1ir98ZpVRp"};